<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ReturnBig`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_843fd887e8__clip0_1_29483)"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.7071 2.29289C17.3166 1.90237 16.6834 1.90237 16.2929 2.29289L7.29976 11.286C7.21533 11.3705 7.14916 11.4662 7.10124 11.5684C6.92197 11.9406 6.98666 12.4009 7.29533 12.7095L16.2986 21.7128C16.6891 22.1033 17.3223 22.1033 17.7128 21.7128C18.1033 21.3223 18.1033 20.6891 17.7128 20.2986L9.41421 12L17.7071 3.70711C18.0976 3.31658 18.0976 2.68342 17.7071 2.29289Z"/></g><defs><clipPath id="svg_843fd887e8__clip0_1_29483"><path d="M0 0H24V24H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconReturnBig',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
